


















import { Component, Prop, Vue } from "vue-property-decorator";
import { DataModules } from "@/store/modules/data";
import { IClient } from "@/models/clients";

@Component
export default class ClientSupportPinMessage extends Vue {
  // Props

  @Prop({ required: true })
  public readonly clientId!: IClient["id"];

  @Prop({ default: "" })
  public readonly supportPin!: IClient["support_pin"];

  // Methods

  public async generateSupportPin() {
    const supportPin = (await this.$store.dispatch(
      `data/${DataModules.CLIENTS}/generateSupportPin`,
      {
        clientId: this.clientId
      }
    )) as string[];

    await this.$store.dispatch(`data/${DataModules.CLIENTS}/updateSupportPin`, {
      clientId: this.clientId,
      supportPin: supportPin.join("")
    });
  }
}
